/**
 * Sticky Navigation Scripts
 *
 * Global component hence it's own file. 
 * 
 * Don't check if 
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <john@chatmandesign.com>
 * @link      http://chatmandesign.com
 */

(function($) {
    let arriveOptions = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

	let header          = '#theme-header';
    let adminBar       = '#wpadminbar';

	let $header         = $('#theme-header');
    let $content        = $('#content');

    let $navDropdowns   = $('.main-menu [class$="-nav-dropdown"]');
    let $menus           = $('.main-menu [id$="-nav"]'); 

    let compactClass    = 'is-compact';
    let hoveredClass    = 'is-hovered';

    function headerContentMargin() {
        // Finally take that darn admin bar into account
        headerHeight = Math.floor( $header.height() );
        if( $content.length ) {
            $content.css('margin-top', `${headerHeight}px`);
        }
    }

    function cd_compact_header(scrollTop) {
        if(scrollTop >= scrollPoint) {
            $header.addClass(compactClass);
		} else {
            $header.removeClass(compactClass);
		}
    }

    function showMenus() {
        if( $(window).width() > 1024 ) {
        } else {
        }
    }

    let headerHeight    = 0;
    let scrollPoint     = 0;

    $(document).arrive(header, arriveOptions, headerContentMargin);

    // adjust for admin bar
    $(document).arrive(adminBar, arriveOptions, function() {
        let adminHeight = $(adminBar).height();
        $header.css('padding-top', `${adminHeight}px`);
        headerContentMargin();
    });

    // DOM READY
    $(function() {
		// Timeout for final header height
		setTimeout(function() {
			headerHeight = $header.outerHeight();
            scrollPoint = headerHeight / 4; // Make header compact at 1/4 scroll distance of header
            cd_compact_header($(window).scrollTop()); // Checks if someone is already past point on load
        }, 1);

        // ON SCROLL

        
    }); // DOM ready

    $(window).on('scroll', function() {
        if( !$header.hasClass(hoveredClass) ){
            cd_compact_header($(window).scrollTop());
        }
    });

    $(window).on('load', function() {
        $navDropdowns.on('click', function() {
            $(this).next().slideToggle();
            //$(this).next().toggleClass('is-dropped');
        });

        headerContentMargin(); 
    });

    $(window).on('resize', function() {
        headerContentMargin();
        showMenus();
    });

})(jQuery);